import { render, staticRenderFns } from "./ContactsSelector.vue?vue&type=template&id=3ccecd72"
import script from "./ContactsSelector.vue?vue&type=script&lang=js"
export * from "./ContactsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports